
/**
 * Get the proper news filename based on language
 */
export function getNewsFileName(language: string): string {
  console.log(`Getting news file for language: ${language}`);
  return language === 'en' ? 'newsen.json' : 'newspl.json';
}
